// Generated by scripts/build-ui-icons.mjs.
export { Copy as default } from "../ui/glyphs-3";
